export function fillArray<T>(array: T[], length: number = 3): T[] {
  const arrayLength = array.length;

  if (arrayLength === length) {
    return array;
  }

  for (let i = arrayLength; i < length; i++) {
    array.push(array[i - 1]!);
  }

  return array;
}
